const state = {
    barColor: '#424242, #424242',
    barImage: '',
    drawer: null,
    mini: true,
    submenu_name: '',
    isStep1Complete: false,
    isStep2Complete: false,
    isStep3Complete: false,
    isStep4Complete: false,
    fromCustomer: null,
    isLoading: false,
    step: 1,
    search_text: "",
    search_times: []
}

const getters = {
    GET_MINI: state => state.mini,
    GET_LOADER: state => state.isLoading,
    GET_SUBMENU_NAME: state => state.submenu_name,
    GET_STEP: state => state.step,
    GET_STEP1_COMPLETE: state => state.isStep1Complete,
    GET_STEP2_COMPLETE: state => state.isStep2Complete,
    GET_STEP3_COMPLETE: state => state.isStep3Complete,
    GET_STEP4_COMPLETE: state => state.isStep4Complete,
    GET_FROM_CUSTOMER: state => state.fromCustomer,
    GET_SE_TEXT: state => state.search_text,
    GET_SE_TIME: state => state.search_times,
}

const mutations = {
    SET_LOADER(state, payload) {
        let timeout
        state.isLoading = payload
        if (payload) {
            timeout = setTimeout(() => {
                state.isLoading = false
            }, 20000)
        } else {
            clearTimeout(timeout);
           
        }

    },
    SET_SE_TEXT(state, payload) {
        state.search_text = payload
    },
    SET_SE_TIME(state, payload) {
        state.search_times = payload
    },
    SET_FROM_CUSTOMER(state, payload) {
        state.fromCustomer = payload
    },
    SET_BAR_IMAGE(state, payload) {
        state.barImage = payload
    },
    SET_STEP(state, payload) {
        state.step = payload
    },
    SET_STEP1_COMPLETE(state, payload) {
        state.isStep1Complete = payload
    },
    SET_STEP2_COMPLETE(state, payload) {
        state.isStep2Complete = payload
    },
    SET_STEP3_COMPLETE(state, payload) {
        state.isStep3Complete = payload
    },
    SET_STEP3_COMPLETE(state, payload) {
        state.isStep4Complete = payload
    },
    SET_MINI_MENU(state, payload) {
        state.mini = payload
    },
    SET_DRAWER(state, payload) {
        state.drawer = payload
    },
    SET_SUBMENU_NAME(state, payload) {
        state.submenu_name = payload

    }
}

const actions = {
}
// Mutations

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}